export default "__VITE_ASSET__Dm1Cb2fO__"